export default __webpack_public_path__ + "static/media/Thumbnail-2.4d433963.svg";